import React from "react";

import { AgeBandedTieredRate } from "../../constants/aquafina";
import { CoverageArrowRow, CoverageRow } from "../table/rows";
import { CoverageCell, CoverageHeaderCell } from "../table/cells";
import { RangeIterator } from "../../utils";

type TierCode = string;
type AgeRange = string;
type RateValue = string;

const AgeBandedTieredRates = ({
  rates,
  headerTitle = "Rates",
}: {
  rates: AgeBandedTieredRate[];
  headerTitle?: string;
}) => {
  const tiersByKey = new Map<TierCode, Map<AgeRange, RateValue[]>>();
  RangeIterator(rates.length, (index) => {
    const rate = rates[index];
    if (!rate) return;

    Object.entries(rate.tiers).forEach(([tierCode, value]) => {
      if (!value) {
        return;
      }
      if (!tiersByKey.has(tierCode)) {
        tiersByKey.set(tierCode, new Map<AgeRange, RateValue[]>());
      }
      const tierMap = tiersByKey.get(tierCode)!;
      value.tiers?.forEach((tierBand) => {
        const tierName = tierBand.name;
        if (!tierName) return;
        if (!tierMap.has(tierName)) {
          tierMap.set(tierName, new Array(rates.length).fill(""));
        }
        tierMap.get(tierName)![index] = tierBand.value;
      });
    });
  });

  const tierCodeLabels = {
    employee: "Employee Only",
    employeeDependent: "Employee + One Dependent",
    employee2Dependents: "Employee + Two Dependents",
    employeeSpouse: "Employee + Spouse",
    spouseOnly: "Spouse Only",
    spouseChildren: "Spouse + Children",
    spouseDependent: "Spouse + Dependent",
    employeeChildren: "Employee + Children",
    childOnly: "Child Only",
    employeeFamily: "Full Family",
  };

  return (
    <>
      <CoverageRow label="Rate Unit">
        {RangeIterator(rates.length, (index) => (
          <CoverageCell value={rates[index].rateUnit} key={index} />
        ))}
      </CoverageRow>
      <CoverageRow label={headerTitle} isWhite>
        {RangeIterator(rates.length, (index) => (
          <CoverageHeaderCell label={""} key={index} />
        ))}
      </CoverageRow>

      {Array.from(tiersByKey.entries()).map(([tierCode, ageMap]) => (
        <React.Fragment key={tierCode}>
          <CoverageArrowRow
            label={
              tierCodeLabels[tierCode as keyof typeof tierCodeLabels] ||
              tierCode
            }
          >
            {RangeIterator(rates.length, (index) => (
              <CoverageHeaderCell label="" key={index} />
            ))}
          </CoverageArrowRow>
          {Array.from(ageMap.entries()).map(([ageRange, values], indexAge) => (
            <CoverageArrowRow
              key={ageRange}
              label={ageRange}
              level={2}
              isWhite={indexAge % 2 !== 0}
            >
              {values.map((value, index) => (
                <CoverageCell
                  value={value}
                  key={`${tierCode}-${ageRange}-${index}`}
                />
              ))}
            </CoverageArrowRow>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default AgeBandedTieredRates;
